<template>
    <div>
        <main id="main">
            <slot />
        </main>
    </div>
</template>

<script>
export default {
    name: "GuestLayout",
}
</script>

<style lang="scss" scoped>

.logo {
    position: absolute;
    left: 1.5rem;
}
</style>
